export default __webpack_public_path__ + "static/media/Logo_TGD_RVB.3980e1d0.png";